export default __webpack_public_path__ + "static/11-a29aa125fb657b9e0921b29bd5ea35bd.jpg";